import { API_PREFIX } from './api.constants';

const base = (courseId: number | string) =>
  `${API_PREFIX}/courses/${courseId}/question-bank`;

export const QUESTION_BANK_ENDPOINTS = {
  CATEGORIES: (courseId: number | string) => `${base(courseId)}/categories`,
  DRAW_IMPACT: (courseId: number | string) => `${base(courseId)}/draw-impact`,
  CATEGORY_DETAIL: (courseId: number | string, categoryId: number | string) =>
    `${base(courseId)}/categories/${categoryId}`,
  SUMMARY: (courseId: number | string) => `${base(courseId)}/summary`,
  QUESTIONS: (courseId: number | string) => `${base(courseId)}/questions`,
  QUESTIONS_IMPORT: (courseId: number | string) => `${base(courseId)}/questions/import`,
  QUESTION_DETAIL: (courseId: number | string, questionId: number | string) =>
    `${base(courseId)}/questions/${questionId}`,
  QUESTION_RESTORE: (courseId: number | string, questionId: number | string) =>
    `${base(courseId)}/questions/${questionId}/restore`,
  QUESTION_PURGE: (courseId: number | string, questionId: number | string) =>
    `${base(courseId)}/questions/${questionId}/purge`,
};

export const EXAM_ENDPOINTS = {
  EXAM: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}`,
  MARKERS: (courseId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/exams/markers`,
  RESULTS: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/results`,
  ATTEMPT_DETAIL: (
    courseId: number | string,
    activityId: number | string,
    attemptId: number | string,
  ) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/${attemptId}/detail`,
  ATTEMPT_REVIEW: (
    courseId: number | string,
    activityId: number | string,
    attemptId: number | string,
  ) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/${attemptId}/review`,
  INFO: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/info`,
  START: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/start`,
  ACTIVE: (courseId: number | string, activityId: number | string) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/active`,
  RESPONSE: (
    courseId: number | string,
    activityId: number | string,
    attemptId: number | string,
    questionId: number | string,
  ) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/${attemptId}/responses/${questionId}`,
  CHECK: (
    courseId: number | string,
    activityId: number | string,
    attemptId: number | string,
    questionId: number | string,
  ) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/${attemptId}/responses/${questionId}/check`,
  SUBMIT: (
    courseId: number | string,
    activityId: number | string,
    attemptId: number | string,
  ) =>
    `${API_PREFIX}/courses/${courseId}/exams/${activityId}/attempts/${attemptId}/submit`,
};

export const MARKING_ENDPOINTS = {
  QUEUE: `${API_PREFIX}/exam-marking/queue`,
  GRADE: (responseId: number | string) =>
    `${API_PREFIX}/exam-marking/responses/${responseId}/grade`,
};
